window.OrcamentoAberto = Backbone.Model.extend({

});

window.OrcamentosAbertos = Backbone.Collection.extend({
    model: OrcamentoAberto
});